<template>
	<div>
		<el-table :data="tableData" show-summary :summary-method="getSummaries">
			<el-table-column label="Date" width="160">
				<template slot-scope="scope">
					<p v-if="scope.row.trade_ref_is_manual != 1" class="top-line text-break">{{
						scope.row.trade_ref_aging_date }}</p>
					<el-input v-else v-model="scope.row.trade_ref_aging_date" type="date" :disabled="(_gHlp.checkAccess(['role_telemarketing']))" ></el-input>
				</template>
			</el-table-column>

			<el-table-column label="Company Name" width="220">
				<template slot-scope="scope">
					<p v-if="scope.row.trade_ref_is_manual != 1" class="top-line text-break">{{
						scope.row.trade_ref_referee_name }}</p>
					<el-input v-else v-model="scope.row.trade_ref_referee_name" :disabled="(_gHlp.checkAccess(['role_telemarketing']))" ></el-input>
				</template>
			</el-table-column>

			<el-table-column prop="trade_ref_credit_limit" sortable width="130px" :formatter="formatCurrency"
				label="Credit Limit">
				<template slot-scope="scope">
					<p v-if="scope.row.trade_ref_is_manual != 1" class="top-line text-break">{{
						scope.row.trade_ref_credit_limit }}</p>
					<el-input v-else v-model="scope.row.trade_ref_credit_limit" :disabled="(_gHlp.checkAccess(['role_telemarketing']))" ></el-input>
				</template>
			</el-table-column>
			<el-table-column prop="trade_ref_outstanding_amt" sortable width="130px" :formatter="formatCurrency"
				label="Current Outstanding">
				<template slot="header" slot-scope="scope">
					<span class="text-break">{{ scope.column.label }}</span>
				</template>
				<template slot-scope="scope">
					<p v-if="scope.row.trade_ref_is_manual != 1" class="top-line text-break">{{
						scope.row.trade_ref_outstanding_amt }}</p>
					<el-input v-else v-model="scope.row.trade_ref_outstanding_amt" :disabled="(_gHlp.checkAccess(['role_telemarketing']))" ></el-input>
				</template>
			</el-table-column>
			<el-table-column prop="trade_ref_current_instalment" sortable label="Current Installment" width="130">
				<template slot="header" slot-scope="scope">
					<span class="text-break">{{ scope.column.label }}</span>
				</template>
				<template slot-scope="scope">
					<el-input v-model="scope.row.trade_ref_current_instalment" :disabled="(_gHlp.checkAccess(['role_telemarketing']))" ></el-input>
				</template>
			</el-table-column>
			<el-table-column prop="trade_ref_special_settlement" sortable label="Special Settlement" width="130">
				<template slot="header" slot-scope="scope">
					<span class="text-break">{{ scope.column.label }}</span>
				</template>
				<template slot-scope="scope">
					<el-input :disabled="(_gHlp.checkAccess(['role_telemarketing'])) || scope.row.trade_ref_is_consolidate"
						v-model="scope.row.trade_ref_special_settlement"></el-input>
				</template>
			</el-table-column>
			<el-table-column prop="trade_ref_consolidate_settlement" width="130" label="Consolidate Settlement">
				<template slot="header" slot-scope="scope">
					<span class="text-break">{{ scope.column.label }}</span>
				</template>
				<template slot-scope="scope">
					<el-input :disabled="(_gHlp.checkAccess(['role_telemarketing'])) || scope.row.trade_ref_is_consolidate" v-model="scope.row.trade_ref_consolidate_settlement"></el-input>
				</template>
			</el-table-column>
			<el-table-column width="auto">
				<template slot-scope="scope">
					<el-switch v-model="scope.row.trade_ref_is_consolidate" active-color="#13ce66" @change="setConsolidate(scope.$index,scope.row)"  :disabled="(_gHlp.checkAccess(['role_telemarketing']))" ></el-switch>
				</template>
			</el-table-column>
			<el-table-column label="New Installment" prop="trade_ref_new_instalment" sortable width="130px">
				<template slot="header" slot-scope="scope">
					<span class="text-break">{{ scope.column.label }}</span>
				</template>
				<template slot-scope="scope">
					<el-input v-model="scope.row.trade_ref_new_instalment" :disabled="(_gHlp.checkAccess(['role_telemarketing']))" ></el-input>
				</template>
			</el-table-column>
			<el-table-column label="Action">
				<template slot-scope="scope">
						<el-button 
								@click="deleteItem(scope.row.trade_ref_id,scope.$index)"
								type="danger" 
								icon="el-icon-close"
								size="mini" 
								circle
								class="p-0"
								v-if="scope.row.trade_ref_is_manual == 1"
                :disabled="(_gHlp.checkAccess(['role_telemarketing']))" 
						></el-button>
				</template>
		</el-table-column>
		</el-table>
		<el-button type="text" @click="addItem" v-if="(!_gHlp.checkAccess(['role_telemarketing']))" >+ Add Trade Reference</el-button>
		<div class="mt-3">
			<b-row class="d-flex justify-content-center">
				<b-col cols="6" md="3">
					<el-button class="bg-primary text-white w-100" @click="saveTable" :loading="is_loading" v-if="(!_gHlp.checkAccess(['role_telemarketing']))" >Save
					</el-button>
				</b-col>
			</b-row>
		</div>
	</div>
</template>
<script>
import { Button, Table, TableColumn, Input, Switch } from 'element-ui'
import { mapState, mapActions } from 'pinia'
import { useCustomerStore } from '@/stores/customerStore'
import { useCreditReportStore } from '@/stores/creditReportStore'
import solutionEventBus from '@/assets/js/EventBus/solutionEventBus.js'

export default {
	props: ['commitments', 'tables'],
	components: {
		[Switch.name]: Switch,
		[Button.name]: Button,
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
		[Input.name]: Input
	},
	data() {
		return {
			current_credit_report_id:null,
			current_customer_id:null,
			is_loading: false,
			tableData: [],
			deleteIds:[]
		}
	},
	computed: {
		...mapState(useCustomerStore, ['current_customer', 'current_commitment']),
	},
	watch: {
		current_commitment: {
			handler(newVal) {
				this.setTable()
			}
		},
		current_customer: {
			handler(newVal) {
				if(newVal){
					this.current_customer_id = newVal.customer_id;
				}
			}
		}
	},
	created() {
		this.setTable()
	},
	methods: {
		...mapActions(useCreditReportStore, ['saveAllTradeRefItems','deleteTradeRefItems']),
		setTable() {
			this.deleteIds = [];
			this.tableData = [];
			if (!_gHlp.isEmpty(this.current_commitment)) {
				this.current_credit_report_id = this.current_commitment.credit_report_id;

				const creditSummary = this.current_commitment;
				if (!_gHlp.isEmpty(creditSummary) && !_gHlp.isEmpty(creditSummary.credit_report_summary.trade_references)) {
					const tradeRef = creditSummary.credit_report_summary.trade_references
					
					this.tableData = tradeRef.map(x => {
							//MODIF FOR SWITCH ELEMENT
							x.trade_ref_is_consolidate = x.trade_ref_is_consolidate == 1 ? true : false;
							return x;
					});
				}
			}
		},
		addItem() {
			this.tableData.push({
				trade_ref_id:null,
				trade_ref_credit_report_id:this.current_commitment ? this.current_commitment.credit_report_id : null,
				trade_ref_referee_name:"",
				trade_ref_referee_tel:"",
				trade_ref_outstanding_amt:"",
				trade_ref_aging:"",
				trade_ref_aging_date:"",
				trade_ref_application_code:"",
				trade_ref_created_by:"",
				trade_ref_updated_by:"",
				trade_ref_credit_limit:"",
				trade_ref_current_instalment:"",
				trade_ref_special_settlement:"",
				trade_ref_consolidate_settlement:"",
				trade_ref_new_instalment:"",
				trade_ref_is_consolidate:false,
				trade_ref_is_manual:1,
			})
		},
		saveTable(){
			this.is_loading = true;
			Promise.all([
				this.saveAllTradeRefItems(this.tableData,this.current_credit_report_id,this.current_customer_id),
				this.deleteTradeRefItems(this.deleteIds)
			]).then(res=>{
				_gNotif.notifySuccess('<b>Trade Reference Items</b> - Successfully Updated.');
				solutionEventBus.$emit('refresh-ctos')
				this.is_loading = false;
			}).catch(e => {
				this.is_loading = false
				_gNotif.errorFunction(e)
			});
		},
		deleteItem(trade_ref_id, index){
			if(!_gHlp.isEmpty(trade_ref_id)){
				this.deleteIds.push(trade_ref_id);
			}
			this.tableData.splice(index,1);
		},
		setConsolidate(index,item){
			if(item.trade_ref_is_consolidate){
				item['trade_ref_consolidate_settlement_prev'] = item.trade_ref_consolidate_settlement;
				item['trade_ref_new_instalment_prev'] = item.trade_ref_new_instalment;

				item.trade_ref_consolidate_settlement = item.trade_ref_outstanding_amt;
				item.trade_ref_new_instalment = 0;
			}else{
				if(!_gHlp.isEmpty(item.trade_ref_consolidate_settlement_prev)){
					item.trade_ref_consolidate_settlement = item.trade_ref_consolidate_settlement_prev
				}
				if(!_gHlp.isEmpty(item.trade_ref_new_instalment_prev)){
					item.trade_ref_new_instalment = item.trade_ref_new_instalment_prev
				}
			}
			this.tableData[index] = item;
		},
		getSummaries(param) {
				const { columns, data } = param;
				const sums = [];
				columns.forEach((column, index) => {
						if (index === 0) {
								sums[index] = 'Total';
								return;
						}
						const values = data.map(item => Number(item[column.property]));
						if (!values.every(value => isNaN(value))) {
								sums[index] = values.reduce((prev, curr) => {
								const value = Number(curr);
								if (!isNaN(value)) {
										return prev + curr;
								} else {
										return prev;
								}
								}, 0).toLocaleString(undefined, {minimumFractionDigits: 2});
						} else {
								sums[index] = '';
						}
				});

				return sums;
		},
		formatCurrency(row, column, cellValue) {
			return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'MYR' }).format(cellValue);
		},
	}
}
</script>